import { Injectable } from "@angular/core";
import { TokenStorageService } from "./token/token-storage.service";
import { RefreshTokenStorageService } from "./refresh-token/refresh-token-storage.service";
import { PKCEVerifierStorageService } from "./p-k-c-e/p-k-c-e-verifier-storage.service";
import { TokenUsageCounterService } from "./token/token-usage-counter.service";
import { CodeChallengeStorageService } from './p-k-c-e/code-challenge-storage.service';
import { AuthModule } from './auth.module';
import { PKCEConfigurationService } from '../configuration/auth/p-k-c-e/p-k-c-e-configuration.service';

@Injectable({
  providedIn: AuthModule
})
export class AuthStorageService {
  get pkceEnabled() {
    return this.pkceConfiguration.enabled;
  }

  get pkceConfiguration() {
    return this.pkceConfigurationService.configuration;
  }

  constructor(
    private tokenStorageService: TokenStorageService,
    private refreshTokenStorageService: RefreshTokenStorageService,
    private verifierStorage: PKCEVerifierStorageService,
    private tokenUsageCounterService: TokenUsageCounterService,
    private pkceConfigurationService: PKCEConfigurationService,
    private codeChallengeStorageService: CodeChallengeStorageService
  ) {}

  clearAll() {
    this.clearToken();
    this.clearExpiresIn();
    this.clearStoreTime();
    this.clearTokenCounterUsage();
    this.clearRefreshToken();
    this.clearVerifier();
    this.clearCodeChallenge();
  }

  clearCodeChallenge() {
    this.codeChallengeStorageService.clear();
  }

  clearExpiresIn() {
    this.tokenStorageService.clearExpiresIn();
  }

  clearStoreTime() {
    this.tokenStorageService.clearStoreTime();
  }

  clearVerifier() {
    return this.verifierStorage.clear();
  }
  loadToken() {
    return this.tokenStorageService.loadToken();
  }
  loadExpiresIn() {
    return this.tokenStorageService.loadExpiresIn();
  }
  clearTokenCounterUsage() {
    return this.tokenUsageCounterService.clear();
  }
  clearRefreshToken() {
    return this.refreshTokenStorageService.clear();
  }
  clearToken() {
    return this.tokenStorageService.clearToken();
  }
  storeToken(token) {
    return this.tokenStorageService.storeToken(token);
  }
  storeExpiresIn(expires_in) {
    return this.tokenStorageService.storeExpiresIn(expires_in);
  }
  storeRefreshToken(refreshToken) {
    return this.refreshTokenStorageService.storeRefreshToken(refreshToken);
  }

  storeTokenStoreTime(time) {
    return this.tokenStorageService.storeStoreTime(time);
  }

  loadTokenStoreTime() {
    return this.tokenStorageService.loadStoreTime();
  }

  clearTokenStoreTime() {
    return this.tokenStorageService.clearStoreTime();
  }
}
